import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import theme from '../../Theming/DefaultTheme';
import { Box, Typography, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import VotingIconButton from './VotingIconButton';
var chipStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 3,
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.common.black,
    padding: 3,
    borderRadius: 30,
    border: '1px solid',
    borderColor: theme.palette.grey[500],
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
    minWidth: 150,
};
var SelectedPlaceChip = function (_a) {
    var selectedPlace = _a.selectedPlace, userVoted = _a.userVoted, onClick = _a.onClick, onRemove = _a.onRemove, onVoteClick = _a.onVoteClick;
    var handleRemoveClick = function (e) {
        e.stopPropagation(); // Prevent any other click action
        onRemove(selectedPlace);
    };
    var handleVoteClick = function (e) {
        e.stopPropagation(); // Prevent any other click action
        onVoteClick(selectedPlace);
    };
    return (_jsxs(Box, { style: chipStyles, onClick: function () { return onClick(selectedPlace); }, children: [_jsx(VotingIconButton, { voteCount: selectedPlace.voteCount, votedOn: userVoted, onClick: handleVoteClick }), _jsx(Typography, { style: { marginTop: 3 }, noWrap: true, variant: 'body2', children: selectedPlace.name }), _jsx(IconButton, { onClick: handleRemoveClick, disabled: selectedPlace.voteCount > 0, sx: {
                    '&:hover': {
                        backgroundColor: 'transparent', // Remove hover background
                    },
                }, children: _jsx(FontAwesomeIcon, { size: 'xs', icon: faXmark }) })] }));
};
export default SelectedPlaceChip;
